module.exports = __webpack_public_path__ + "static/media/NEXXT-Light.25a25599.png";